import { render, staticRenderFns } from "./UserView_Duels.vue?vue&type=template&id=6b8ae050&scoped=true&"
import script from "./UserView_Duels.vue?vue&type=script&lang=js&"
export * from "./UserView_Duels.vue?vue&type=script&lang=js&"
import style0 from "./UserView_Duels.vue?vue&type=style&index=0&id=6b8ae050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8ae050",
  null
  
)

export default component.exports